<template>
  <div>
    <div class="por-bg-a">
      <div class="por-box-view clearfix">
        <div class="por-box-location" ref="tabTop1">
          <Icon custom="ich-icon ich-icon-map" size="18" />
          <span>
            全部分类 | {{ typeName }} | {{ labelName }} | {{ majorName }}
          </span>
        </div>
        <div class="por-box-b">
          <div
            v-for="(item, index) in majorProductList.slice(0, 4)"
            :key="index"
            :title="item.courseName"
            class="por-boxb-a"
            :class="{ selected: item.courseId == currentProduct.courseId }"
            @mouseenter="handerCourseSpecial(item)"
          >
            <span class="por-boxb-title">{{ item.courseName }}</span>
            <div class="por-boxb-drop">
              <div class="por-boxb-drop-bg">
                <div
                  v-for="(special, speIndex) in courseSpecialList"
                  :key="speIndex"
                  class="por-boxb-drop-item"
                >
                  <a
                    @click="changeCourseSpecial(item, special)"
                    :class="{ selected: special.cstId == currentSpecial.cstId }"
                    >{{ special.specialName }}
                  </a>
                  <div class="can-live" v-if="special.hasLive">包含直播</div>
                </div>
              </div>
            </div>
          </div>

          <div class="por-boxb-b">
            <div class="por-boxb-title">
              <span>{{ currentProduct.courseName }}</span>
              <Icon type="md-arrow-dropdown" size="16" />
            </div>

            <ul class="por-boxb-list">
              <li
                v-for="(item, index) in majorProductList"
                :key="index"
                :class="{ selected: tempCourse.courseId == item.courseId }"
                @mouseenter="handerCourseSpecial(item, true)"
                @mouseleave="handerCourseSpecialHide()"
              >
                <a :title="item.courseName">{{ item.courseName }}</a>
              </li>
            </ul>
            <div
              class="por-boxb-drop"
              v-if="tempSpecialVisible"
              @mouseenter="handerCourseSpecial(tempCourse, true)"
              @mouseleave="handerCourseSpecialHide()"
            >
              <div
                class="por-boxb-drop-item"
                v-for="(special, speIndex) in courseSpecialList"
                :key="speIndex"
              >
                <a
                  @click="changeCourseSpecial(tempCourse, special)"
                  :class="{ selected: special.cstId == currentSpecial.cstId }"
                  >{{ special.specialName }}</a
                >
                <div class="can-live" v-if="special.hasLive">包含直播</div>
              </div>
            </div>
          </div>
        </div>
        <div class="por-box-c">
          <video-player
            :loading="!isLoaded"
            :tipText="noVideoText"
            :width="864"
          ></video-player>
        </div>
        <div class="por-box-d">
          <course-catalog v-if="currentSpecial.type === 1"></course-catalog>
          <review-catalog v-if="currentSpecial.type === 2"></review-catalog>
        </div>
      </div>
    </div>

    <!--班型图片-->
    <div class="class-type-img" v-if="tabList[2].show">
      <div class="topic-title" ref="tabTop3" :class="{ blue: tabList[1].show }">
        <div class="title-number">
          <!-- {{ tabList[1].show ? "02" : "01" }} -->
          01
        </div>
        <div class="title-text">{{ tabList[2].name }}</div>
      </div>
      <div class="image">
        <img :src="concatImageUrl(tabList[2].data, 0, 0)" alt />
      </div>
    </div>

    <!-- 相关班型商品列表--套餐班 -->
    <div class="class-multip" v-show="multipleSpecialList.length > 0">
      <div class="class-type-title">
        <!-- <img src="../../assets/images/v3/special-m02-title.png" /> -->
        <div class="topic-title">
          <div class="title-number">
            <!-- eslint-disable -->
            {{
              "0" +
                tabList.filter((m) => m.show && !m.hide && m.key <= 3).length
            }}
          </div>
          <div class="title-text">
            套餐班
            <p>多种套餐班助力备考</p>
          </div>
        </div>
      </div>

      <div class="container por-box-wrapper">
        <div class="por-box-e clearfix">
          <a
            class="por-boxe-b"
            :class="{ selected: item.id == multipleSpecialId }"
            v-for="(item, index) in multipleSpecialList.slice(0, 9)"
            :key="index"
            :title="item.name"
            @click="changeSpecial(item.id, 1)"
            >{{ item.name }}</a
          >
          <div class="por-boxe-other" v-if="multipleSpecialList.length >= 9">
            <a href="javascript:;">更多</a>
            <ul class="por-boxe-drop">
              <li
                v-for="(item, index) in multipleSpecialList.slice(9)"
                @click="changeSpecial(item.id, 1)"
                :title="item.name"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
        </div>
        <div class="pro-box-content">
          <div class="por-box-f">
            <div class="por-boxf-a">课程专业名称</div>
            <div class="por-boxf-b">课时</div>
            <div class="por-boxf-b">价格</div>
            <div class="por-boxf-c">免费体验</div>
            <div class="por-boxf-d">购买</div>
          </div>
          <div
            class="por-box-g clearfix"
            v-for="(item, index) in multipleProductList"
            :key="index"
          >
            <div class="can-integral" v-if="item.isIntegral"></div>
            <div class="can-live" v-if="item.hasLive"></div>
            <div :title="item.name" class="por-boxg-a">{{ item.name }}</div>
            <div class="por-boxg-b">{{ item.pptTime }}</div>
            <div class="por-boxg-b" style="color: #ff3115">
              <span
                v-show="formatPrice(item.discountPrice, item.price)[0] !== '-1'"
                >￥{{ formatPrice(item.discountPrice, item.price)[0] }}</span
              >
            </div>
            <div class="por-boxg-c">
              <router-link
                :to="{ name: 'MajorDetail', params: { id: item.productId } }"
              >
                <Icon custom="ich-icon ich-icon-play" size="16" />
                免费体验
              </router-link>
            </div>
            <div class="por-boxg-d">
              <router-link
                :to="{ name: 'MajorDetail', params: { id: item.productId } }"
              >
                <div>购买</div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 相关班型商品列表--单科班 -->
    <div class="class-single" v-show="singleSpecialList.length > 0">
      <div class="class-type-title">
        <!-- <img src="../../assets/images/v3/special-m03-title.png" /> -->
        <div class="topic-title">
          <div class="title-number">
            <!-- eslint-disable -->
            {{
              "0" +
                (tabList.filter((m) => m.show && !m.hide && m.key <= 3).length +
                  (multipleSpecialList.length > 0 ? 1 : 0))
            }}
            <!-- eslint-disable -->
          </div>
          <div class="title-text">
            单科班
            <p>针对性、解决课程难题</p>
          </div>
        </div>
      </div>

      <div class="container por-box-wrapper">
        <div class="por-box-e clearfix">
          <a
            class="por-boxe-b"
            :class="{ selected: item.id == singleSpecialId }"
            v-for="(item, index) in singleSpecialList.slice(0, 9)"
            :key="index"
            :title="item.name"
            @click="changeSpecial(item.id, 2)"
            >{{ item.name }}</a
          >
          <div class="por-boxe-other" v-if="singleSpecialList.length >= 9">
            <a href="javascript:;">更多</a>
            <ul class="por-boxe-drop">
              <li
                v-for="(item, index) in singleSpecialList.slice(9)"
                @click="changeSpecial(item.id, 1)"
                :title="item.name"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
        </div>
        <div class="pro-box-content">
          <div class="por-box-f">
            <div class="por-boxf-a">课程专业名称</div>
            <div class="por-boxf-b">课时</div>
            <div class="por-boxf-b">价格</div>
            <div class="por-boxf-c">免费体验</div>
            <div class="por-boxf-d">购买</div>
          </div>
          <div
            class="por-box-g clearfix"
            v-for="(item, index) in singleProductList"
            :key="index"
          >
            <div class="can-integral" v-if="item.isIntegral"></div>
            <div class="can-live" v-if="item.hasLive"></div>
            <div :title="item.name" class="por-boxg-a">{{ item.name }}</div>
            <div class="por-boxg-b">{{ item.pptTime }}</div>
            <div class="por-boxg-b" style="color: #ff3115">
              <span
                v-show="formatPrice(item.discountPrice, item.price)[0] !== '-1'"
                >￥{{ formatPrice(item.discountPrice, item.price)[0] }}</span
              >
            </div>
            <div class="por-boxg-c">
              <router-link
                :to="{ name: 'CourseDetail', params: { id: item.productId } }"
              >
                <Icon custom="ich-icon ich-icon-play" size="16" />
                免费体验
              </router-link>
            </div>
            <div class="por-boxg-d">
              <router-link
                :to="{ name: 'CourseDetail', params: { id: item.productId } }"
              >
                <div>购买</div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 价值展示 -->
    <div class="por-banner" ref="tabTop4" v-if="tabList[1].show">
      <div class="banner-title">
        <!-- <img src="../../assets/images/v3/special-m01-title.png" /> -->
        <div class="topic-title">
          <div class="title-number">
            {{
              "0" +
                (tabList.filter((m) => m.show && !m.hide && m.key <= 3).length +
                  (multipleSpecialList.length > 0 ? 1 : 0) +
                  (singleSpecialList.length > 0 ? 1 : 0))
            }}
          </div>
          <div class="title-text">{{ tabList[1].name }}</div>
        </div>
      </div>
      <ul
        class="banner-list"
        v-if="tabList[1].data && tabList[1].data.length > 0"
      >
        <li>
          <div class="banner-item">
            <div class="banner-icon">
              <img :src="concatImageUrl(tabList[1].data[0][0], 380, 260)" />
              <img :src="concatImageUrl(tabList[1].data[0][1], 380, 260)" />
            </div>
          </div>
        </li>
        <li>
          <div class="banner-item">
            <div class="banner-icon">
              <img :src="concatImageUrl(tabList[1].data[1][0], 380, 260)" />
              <img :src="concatImageUrl(tabList[1].data[1][1], 380, 260)" />
            </div>
          </div>
        </li>
        <li>
          <div class="banner-item">
            <div class="banner-icon">
              <img :src="concatImageUrl(tabList[1].data[2][0], 380, 260)" />
              <img :src="concatImageUrl(tabList[1].data[2][1], 380, 260)" />
            </div>
          </div>
        </li>
      </ul>
    </div>

    <!-- 专业介绍 -->
    <div
      class="por-major-intro"
      ref="tabTop2"
      v-if="tabList[3].show"
      v-html="tabList[3].data"
    ></div>

    <!-- 信息表单入口 -->
    <div class="form-entry" ref="tabTop5" v-if="tabList[4].show">
      <img :src="tabList[4].data" @click="handleFormEntry" />
    </div>

    <!-- 相关文章 -->
    <div class="about-article-wrapper" ref="tabTop6" v-if="tabList[5].show">
      <div class="topic-title">
        <div class="title-number">
          {{
            "0" +
              (tabList.filter((m) => m.show && m.key <= 3).length +
                (multipleSpecialList.length > 0 ? 1 : 0) +
                (singleSpecialList.length > 0 ? 1 : 0))
          }}
        </div>
        <div class="title-text">{{ tabList[5].name }}</div>
      </div>
      <div class="article-container">
        <!-- <div class="article-bg"></div> -->
        <div class="article-item">
          <div class="article-title">
            <router-link
              :to="{
                name: 'NewsTopic',
                query: { m: majorId, n: this.tabList[5].name },
              }"
              >查看更多>></router-link
            >
          </div>
          <div class="article-list">
            <div
              class="list-item"
              v-for="(item, index) in articleList.slice(0, 4)"
              :key="index"
            >
              <a href="javascript:;" @click="articleExtend(item)">
                <template v-if="item.active">收起</template>
                <template v-else>展开</template>
                <Icon v-if="item.active" type="md-arrow-dropup" />
                <Icon v-else type="md-arrow-dropdown" />
              </a>
              <div class="list-title">
                <span class="title-dot">{{ index + 1 }}</span>
                <span class="title-text">{{ item.title }}</span>
              </div>
              <div class="list-summary" :class="{ extend: item.active }">
                <div class="summary-text" v-html="item.content"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 侧边栏导航 -->
    <div class="sider-nav" :class="{ 'put-away': !siderNavVisible }">
      <div class="pos" @click="switchSiderNav">
        <Icon v-if="siderNavVisible" type="ios-arrow-back" />
        <Icon v-else type="ios-arrow-forward" />
      </div>
      <div
        v-for="(item, index) in tabList.filter((m) => m.show && !m.hide)"
        :key="index"
        class="nav-item"
        :class="{ selected: tabKey == item.key }"
        @click="scrollView(item)"
      >
        {{ item.name }}
      </div>
      <div class="nav-qrcode" v-if="tabQrcode">
        <div class="qrcode-img">
          <img :src="concatImageUrl(tabQrcode, 80, 80)" alt="qrcode" />
        </div>
        <div class="qrcode-text">手机扫一扫</div>
      </div>
    </div>

    <!-- 信息表单弹窗 -->
    <Modal
      v-if="tabList[4].show"
      v-model="formEntryVisible"
      :title="tabList[4].name"
      class-name="vertical-center-modal"
      :mask-closable="false"
    >
      <div style="width: 90%; margin: 0 auto">
        <h3>{{ formDataInfo.name }}</h3>
        <p style="color: #999; margin: 8px 0 24px 0">
          {{ formDataInfo.remark }}
        </p>
      </div>
      <Form
        ref="formDataList"
        :model="formDataList"
        :label-width="130"
        style="width: 400px"
      >
        <FormItem
          v-for="(item, index) in formDataList.items"
          :key="index"
          :label="item.title"
          :prop="'items.' + index + '.value'"
          :rules="item.rules"
        >
          <!-- :rules="{ required: true, message: '请输入', trigger: 'blur' }" -->
          <!-- 输入框 -->
          <template v-if="item.type == 'input'">
            <Input v-model="item.value" :placeholder="item.placeholder"></Input>
          </template>
          <!-- 选择框（单选，多选，单选下拉，多选下拉） -->
          <template v-else-if="item.type == 'radio'">
            <!-- 单选 -->
            <template v-if="item.multiple == 'false' || !item.multiple">
              <!-- 平铺 -->
              <RadioGroup v-model="item.value" v-if="item.showStyle == 'tiled'">
                <Radio
                  :label="radio.label"
                  v-for="(radio, ri) in item.options.filter((m) => !m.flag)"
                  :key="ri"
                >
                  <span>{{ radio.label }}</span>
                </Radio>
              </RadioGroup>
              <!-- 下拉 -->
              <Select v-else v-model="item.value" style="width: 260px">
                <Option
                  v-for="(sopt, soi) in item.options.filter((m) => !m.flag)"
                  :value="sopt.value"
                  :key="soi"
                  >{{ sopt.label }}</Option
                >
              </Select>
            </template>
            <!-- 多选 -->
            <template v-else>
              <!-- 平铺 -->
              <CheckboxGroup
                v-model="item.value"
                v-if="item.showStyle == 'tiled'"
              >
                <Checkbox
                  v-for="(checkbox, ci) in item.options.filter((m) => !m.flag)"
                  :key="ci"
                  :label="checkbox.label"
                >
                  <span>{{ checkbox.label }}</span>
                </Checkbox>
              </CheckboxGroup>
              <!-- 下拉 -->
              <Select v-else v-model="item.value" style="width: 260px" multiple>
                <Option
                  v-for="(mopt, moi) in item.options.filter((m) => !m.flag)"
                  :value="mopt.value"
                  :key="moi"
                  >{{ mopt.label }}</Option
                >
              </Select>
            </template>
          </template>
          <!-- 日期选择 -->
          <template v-else-if="item.type == 'date'">
            <DatePicker
              type="date"
              placeholder="请选择"
              style="width: 200px"
              v-model="item.value"
              format="yyyy-MM-dd"
            ></DatePicker>
          </template>
          <!-- 地址选择 -->
          <template v-else-if="item.type == 'address'">
            <Cascader
              :data="formAddressTree"
              v-model="formAddressVal"
            ></Cascader>
            <Input
              v-if="item.showAddress == '3'"
              v-model="item.value"
              type="textarea"
              placeholder="请输入详细地址..."
              :autosize="{ minRows: 2, maxRows: 2 }"
              style="margin-top: 16px"
            />
          </template>
          <template v-else-if="item.type == 'cascader'">
            <span>
              <Cascader :data="formCasTree" v-model="formCasVal"></Cascader>
            </span>
          </template>
          <template v-else>数据类型暂不支持</template>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="formEntryVisible = false">取消</Button>
        <Button type="primary" @click="onFormSubmit('formDataList')"
          >确定</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import VideoPlayer from "../../components/common/VideoPlayer";
import CourseCatalog from "../../components/mall/CourseCatalog";
import ReviewCatalog from "../../components/mall/ReviewCatalog";
import { mall } from "../../request";

import { getAreaTreeData } from "../../utils/areaList";

export default {
  mixins: [siteMixin],
  data() {
    return {
      // popVisible: true,
      // popListVisible: true,
      siderNavVisible: true,
      tabKey: 1,
      tabList: [
        {
          key: 1,
          name: "教学试听",
          show: false,
          data: "",
          top: 0,
        },
        {
          key: 2,
          name: "价值展示",
          show: false,
          hide: true,
          data: [],
          top: 700,
        },
        {
          key: 3,
          name: "辅助方案",
          show: false,
          top: 700,
          data: "",
        },
        {
          key: 4,
          name: "项目介绍",
          show: false,
          data: "",
          top: 0,
        },
        {
          key: 5,
          name: "信息采集",
          show: false,
          top: 0,
        },
        {
          key: 6,
          name: "相关文章",
          show: false,
          top: 0,
        },
      ],
      tabQrcode: "",
      typeName: "",
      labelName: "",
      majorName: "",
      majorPic: "",
      majorContent: "",
      majorProductList: [], //播放器上方商品(课程)列表
      currentProduct: {},
      tempCourse: {}, //过度课程，用于右侧更多课程及相关班型着色
      tempSpecialVisible: false,
      courseSpecialList: [], //班型列表
      currentSpecial: {}, //当前班型
      noVideoText: "", //无视频时提示文本
      sideArticleList: [],
      singleSpecialId: 0, //单科
      multipleSpecialId: 0, //套餐
      singleSpecialList: [],
      multipleSpecialList: [],
      singleProductList: [],
      multipleProductList: [],
      isLoaded: false,
      articleList: [],
      formEntryVisible: false, //信息表单弹窗
      formDataInfo: {
        name: "",
        remark: "",
        tip: "",
      }, //表单信息
      formDataList: { items: [] }, //表单项数据
      formAddressVal: [], //表单地址的级联值
      formAddressTree: [], //地址树状列表，省市区三级
      formCasVal: [], //表单级联类型值
      formCasTree: [], //表单级联类型的级联数据
    };
  },
  watch: {
    $route(to, from) {
      if (to.params.id !== from.params.id) {
        this.reloadPage();
      }
    },
  },
  beforeMount() {
    this.initMajorInfo();
  },
  mounted() {
    this.getMajorProductList();
    this.setViewScrollTab();
  },
  methods: {
    initMajorInfo() {
      this.majorId = this.$route.params.id;
      mall.getMajorInfo(this.siteConfig.agencyId, this.majorId).then((res) => {
        //console.log("majorInfo", res);
        if (res.status === 1) {
          const result = res.data;
          //this.majorName = result.majorName;
          this.majorPic = result.picFilename1;
          this.majorContent = result.majorBrief;
          //边栏处理
          // this.sideArticleList = result.specialtypearticleList;
          // if (this.sideArticleList.length < 1) this.popVisible = false;
          this.tabQrcode = result.navQrCode;
          const sideNav = result.navigation;
          sideNav.forEach((item) => {
            const tab = this.tabList.find((m) => m.key == item.id);
            if (tab) {
              tab.name = item.name;
              tab.show = true;
              tab.data = item.images || item.content;
              if (item.templateId) {
                tab.templateId = item.templateId;
              }
              if (item.articles && item.articles.length > 0) {
                item.articles.forEach((art, index) => {
                  art.active = true;
                  // if (index === 0) {
                  //   art.active = true;
                  // } else {
                  //   art.active = false;
                  // }
                });
                this.articleList = item.articles;
              }
            }
          });
          //开发时用，文便调试，调用信息采集表单
          //this.handleFormEntry();

          //单科班处理
          this.singleSpecialList = result.dmSpecialstypeListOne;
          if (this.singleSpecialList && this.singleSpecialList.length >= 1) {
            this.singleSpecialId = this.singleSpecialList[0].id;
            this.singleProductList = this.singleSpecialList[0].productVOs;
          }
          //套餐班处理
          this.multipleSpecialList = result.dmSpecialstypeListTwo;
          if (
            this.multipleSpecialList &&
            this.multipleSpecialList.length >= 1
          ) {
            this.multipleSpecialId = this.multipleSpecialList[0].id;
            this.multipleProductList = this.multipleSpecialList[0].productVOs;
          }

          this.setMetaData(this.majorName);
        }
      });
      this.getMajorLocation();
    },
    getMajorLocation() {
      mall.getMajorLocation(this.majorId).then((res) => {
        //console.log("majorLocation", res);
        if (res.status === 1) {
          this.typeName = res.data.typeName;
          this.labelName = res.data.lableName;
          this.majorName = res.data.majorName;
        }
      });
    },
    handerCourseSpecial(item, other) {
      if (other) {
        this.tempCourse = item;
        this.tempSpecialVisible = true;
      }
      this.courseSpecialList = item.coursespecialtypeList;
    },
    handerCourseSpecialHide() {
      //this.tempCourse = {};
      this.tempSpecialVisible = false;
    },
    changeCourseSpecial(item, special) {
      if (special.cstId == this.courseSpecialId) return;
      this.currentProduct = item;
      this.setCourseId(item.courseId);
      this.currentSpecial = special;
      this.setCourseSpecialId(special.cstId);
      this.getCourseCatalog();
      this.tempSpecialVisible = false;
    },
    getMajorProductList() {
      //初始化班型ID为0;
      this.setCourseSpecialId(0);
      //请求数据
      mall
        //.getMajorProductList(this.siteConfig.agencyId, this.majorId)
        .getMajorCourseList(this.siteConfig.agencyId, this.majorId)
        .then((res) => {
          //console.log("majorCourseList", res);
          if (res.status === 1) {
            this.majorProductList = res.data;
            if (this.majorProductList.length > 0) {
              //课程处理
              const vidoeProduct = this.majorProductList.find(
                (m) => m.isTryLook === 1
              );
              if (vidoeProduct) {
                this.currentProduct = vidoeProduct;
              } else {
                this.currentProduct = this.majorProductList[0];
              }
              this.setCourseId(this.currentProduct.courseId);

              //班型处理
              const specialList = this.currentProduct.coursespecialtypeList;
              if (specialList && specialList.length > 0) {
                //当前无班型时给默认值
                this.courseSpecialList = specialList;
                if (this.courseSpecialId == 0) {
                  const videoSpecial = specialList.find(
                    (m) => m.isTryLook === 1
                  );
                  if (videoSpecial) {
                    this.currentSpecial = videoSpecial;
                  } else {
                    this.currentSpecial = specialList[0];
                  }
                  //设当前课程班型ID
                  this.setCourseSpecialId(this.currentSpecial.cstId);
                  //取课程目录
                  this.getCourseCatalog();
                }
              } else {
                this.isLoaded = true;
              }
            } else {
              this.isLoaded = true;
            }
          }
        });
    },
    getCourseCatalog() {
      mall
        .getCourseCatalog(
          this.courseId,
          this.courseSpecialId,
          this.currentSpecial.type,
          this.loginUser.userId,
          this.siteConfig.agencyId
        )
        .then((res) => {
          console.log("catalog", res);
          if (res.status === 1) {
            this.isLoaded = true;

            //无目录时处理
            if (!res.data || res.data.length == 0) {
              this.setCourseCatalog([]);
              this.setPptId("");
              this.setVideoId("");
              if (this.currentSpecial.type === 2) {
                this.noVideoText = "该班型视频正在准备中";
              } else {
                this.noVideoText = "找不到该课程班型试看视频，请购买后观看";
              }
            }

            //debugger
            //章节
            if (this.currentSpecial.type === 1) {
              this.setCourseCatalog(res.data);
              //查找并设置视频ID
              if (res.data.length > 0) {
                const one = res.data[0];
                if (one.childList.length > 0) {
                  const two = one.childList[0];
                  if (two.childList.length > 0) {
                    const three = two.childList[0];
                    if (three.isTryLook == 1) {
                      this.setVideoId(three.bVideoId);
                    } else {
                      this.noVideoText =
                        "当前课程视频不支持试看，请购买后进行学习";
                    }
                  }
                }
              }
              //END
            }
            //串讲
            if (
              this.currentSpecial.type === 2 &&
              res.data &&
              res.data.length > 0
            ) {
              const reviewPptList = res.data[0].pptList || [];
              const liveList = res.data[0].live;
              let resultList = [];
              if (reviewPptList && reviewPptList.length) {
                resultList = reviewPptList.map((m) => {
                  return {
                    type: 1,
                    ...m,
                  };
                });
              }
              if (liveList && liveList.length) {
                const liveTemp = liveList.map((m) => {
                  return {
                    type: 2,
                    isTryLook: 0,
                    ...m,
                  };
                });
                resultList = [...resultList, ...liveTemp];
              }
              if (
                (resultList && resultList.length) ||
                (reviewPptList && reviewPptList.length > 0)
              ) {
                this.setReviewCatalog(resultList);
                let current = reviewPptList[0];
                if (current.isTryLook === 1) {
                  this.setPptId(current.PptId);
                  this.setVideoId(current.bVideoId);
                } else {
                  this.noVideoText = "当前课程视频不支持试看，请购买后进行学习";
                }
              }
            }
          }
        });
    },
    changeSpecial(id, action) {
      if (action === 1) {
        this.multipleSpecialId = id;
      } else {
        this.singleSpecialId = id;
      }
      this.getSpecialProductList(action);
    },
    getSpecialProductList(action) {
      let id = action === 1 ? this.multipleSpecialId : this.singleSpecialId;
      mall
        .getMajorSpecialProductList(this.siteConfig.agencyId, id, this.majorId)
        .then((res) => {
          if (action === 1) {
            this.multipleProductList = res.data;
          } else {
            this.singleProductList = res.data;
          }
        });
    },
    switchSiderNav() {
      this.siderNavVisible = !this.siderNavVisible;
    },
    scrollView(item) {
      this.tabKey = item.key;
      this.setViewTop();
      //alert(item.top);
      this.clickScroll = true;
      this.currentScrollTop = document.documentElement.scrollTop;
      this.targetScrollTop = item.top;
      window.scroll({ top: item.top, behavior: "smooth" });
    },
    setViewTop() {
      const fixTop = 100;
      const scrollTop = document.documentElement.scrollTop;
      this.tabList
        .filter((m) => m.show)
        .forEach((item, index) => {
          let tabTop = undefined;
          if (item.key === 3) {
            tabTop = this.$refs.tabTop3.getBoundingClientRect();
          }
          if (item.key === 4) {
            tabTop = this.$refs.tabTop4.getBoundingClientRect();
          }
          if (item.key === 5) {
            tabTop = this.$refs.tabTop5.getBoundingClientRect();
          }
          if (item.key === 6) {
            tabTop = this.$refs.tabTop6.getBoundingClientRect();
          }
          if (tabTop) {
            item.top = tabTop.top + scrollTop - fixTop;
          }
        });
    },
    setViewScrollTab() {
      const fixTop = 300;
      this.tabKey = false;
      this.tabKey = 0;
      window.onscroll = () => {
        let tabTop = [];
        this.tabList.forEach((item, index) => {
          const tabObj = this.$refs[`tabTop${index + 1}`];
          if (tabObj) {
            tabTop[index] = tabObj.getBoundingClientRect().top;
          } else {
            tabTop[index] = -1;
          }
        });
        let tabScrollKey = 1;
        for (let i = 0; i < tabTop.length; i++) {
          if (tabTop[i] !== -1 && tabTop[i] < fixTop) {
            tabScrollKey = i + 1;
          }
        }

        //定位标识处理
        if (!this.clickScroll) {
          this.tabKey = tabScrollKey;
        }
        let scrollTop = document.documentElement.scrollTop;
        if (typeof this.targetScrollTop != "undefined" && this.clickScroll) {
          //this.targetScrollTop += 100;
          let isUp =
            this.currentScrollTop > this.targetScrollTop ||
            this.targetScrollTop == 0;
          let isDown = this.currentScrollTop < this.targetScrollTop;

          if (isDown && this.targetScrollTop <= scrollTop) {
            this.tabKey = tabScrollKey;
            this.clickScroll = false;
          }
          if (isUp && this.targetScrollTop >= scrollTop) {
            this.tabKey = tabScrollKey;
            this.clickScroll = false;
          }
        }
      };
    },
    articleExtend(item) {
      item.active = !item.active;
    },
    handleCasData(data) {
      const {
        firstCascaderArray,
        secondCascaderArray,
        thirdCascaderArray,
        fourthCascaderArray,
      } = data;
      let arrHandle = (...args) => {
        if (args.length < 1) return [];
        const map = new Map();
        args.shift().forEach((item) => {
          if (item.id) map.set(item.id, { ...item, children: [] });
        });
        let son = arrHandle(...args);
        son.forEach((tem) => {
          let get = map.get(tem.pid);
          get.children.push(tem);
          map.set(tem.pid, get);
        });
        let array = [];
        for (let [, value] of map) {
          array.push(value);
        }
        return array;
      };
      const result = arrHandle(
        firstCascaderArray,
        secondCascaderArray,
        thirdCascaderArray,
        fourthCascaderArray
      );
      return result;
    },
    handleFormEntry() {
      mall.getFormData(this.tabList[4].templateId).then((res) => {
        //console.log(res);
        if (res.status === 1) {
          this.formDataInfo.name = res.data.title;
          this.formDataInfo.remark = res.data.intro;
          this.formDataInfo.tip = res.data.successtips;
          //处理字顶列表
          const formFields = JSON.parse(res.data.templatejson);
          formFields.forEach((item) => {
            item.value = "";
            if (item.type == "radio" && item.multiple == "true") {
              item.value = [];
            }
            if (item.type == "address") {
              //取地区
              this.formAddressTree = getAreaTreeData(
                Number(item.showAddress) + 1
              );
            }
            if (item.type == "cascader") {
              this.formCasTree = this.handleCasData(item);
              console.log("treeData", this.formCasTree);
            }

            //设置验证规则
            item.rules = [];
            if (item.require) {
              const errTip = item.type == "input" ? "请输入" : "请选择";
              let dataType =
                item.type == "radio" && item.multiple == "true"
                  ? "array"
                  : "string";
              if (item.type == "date") {
                dataType = "date";
              }
              item.rules.push({
                required: true,
                type: dataType,
                message: `${errTip}${item.title}`,
                trigger: "change",
              });
            }
            //针对表单各类型验证
            if (item.type == "input" && item.regExp) {
              if (item.regExp == "number") {
                item.rules.push({
                  type: "string",
                  pattern: /^[0-9]*$/,
                  message: "请输入数字",
                  trigger: "change",
                });
              }
              if (item.regExp == "letter") {
                item.rules.push({
                  type: "string",
                  pattern: /^[A-Za-z]+$/,
                  message: "请输入纯字母",
                  trigger: "change",
                });
              }
              if (item.regExp == "chinese") {
                item.rules.push({
                  type: "string",
                  pattern: /^[\u4e00-\u9fa5]{0,}$/,
                  message: "请输入中文字符",
                  trigger: "change",
                });
              }
              if (item.regExp == "email") {
                item.rules.push({
                  type: "email",
                  message: "请输入正确的邮箱",
                  trigger: "change",
                });
              }
              if (item.regExp == "mobile") {
                item.rules.push({
                  pattern: /^(1[3-9][0-9]{9})$/,
                  message: "请输入手机号码",
                  trigger: "change",
                });
              }
              if (item.regExp == "idcard") {
                item.rules.push({
                  pattern: /^((\d{18})|([0-9x]{18})|([0-9X]{18}))$/,
                  message: "请输入正确的身份证号",
                  trigger: "change",
                });
              }
            }
          });
          this.formDataList.items = formFields;
          console.log(this.formDataList.items);
          this.formEntryVisible = true;
        }
      });
    },
    onFormSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          const formReqData = JSON.parse(
            JSON.stringify(this.formDataList.items)
          );
          formReqData.forEach((item) => {
            //重设单选数值为数组
            if (item.type == "radio" && item.multiple == "false") {
              item.value = [item.value];
            }
            //重设日期数值
            if (item.type == "date") {
              item.value = item.value.split("T")[0];
            }
            //重设地址数值
            if (item.type == "address") {
              let address = "";
              this.formAddressVal.forEach((val) => {
                address += val;
              });
              item.value = address + item.value;
            }
          });

          //长度验证
          let errorList = [];
          formReqData.forEach((item) => {
            if (item.type == "input" && item.regExp) {
              if (item.regExp == "number") {
                if (
                  Number(item.value) < item.minLength ||
                  Number(item.value) > item.maxLength
                ) {
                  errorList.push(
                    `${item.title} 最小值为 ${item.minLength} 最大值为 ${item.maxLength}，请检查！`
                  );
                }
              } else {
                if (
                  item.value.length > item.maxLength ||
                  item.value.length < item.minLength
                ) {
                  errorList.push(
                    `${item.title} 字符长度应为 ${item.minLength}-${item.maxLength}，请检查！`
                  );
                }
              }
            }
          });
          if (errorList.length > 0) {
            this.$Message.warning(errorList[0]);
            return;
          }

          //提交表单数据TODO
          const requestModel = {
            agencyid: this.siteConfig.agencyId,
            templateid: this.tabList[4].templateId,
            projectname: this.majorName,
            scene: 1,
            loginusername: this.loginUser?.userName,
            templatedatas: JSON.stringify(formReqData),
          };
          mall.saveFormData(requestModel).then((res) => {
            //console.log(res);
            if (res.status === 1) {
              this.formEntryVisible = false;
              this.$Message.success(this.formDataInfo.tip);
            } else {
              this.$Message.error("提交失败");
            }
          });

          //this.$Message.success("Success!");
          //console.log("formData", formReqData);
        } else {
          //this.$Message.error("Fail!");
        }
      });
      return;
    },
  },
  components: {
    VideoPlayer,
    CourseCatalog,
    ReviewCatalog,
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/var.less";
.por-bg-a {
  width: 100%;
  padding-top: 70px;
  padding-bottom: 300px;
  margin-bottom: -250px;
  background: url("../../assets/images/v3/player-bg.png") no-repeat bottom
    center;
  .por-box-view {
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    .por-box-location {
      height: 70px;
      line-height: 70px;
      color: #999;
      font-size: 16px;
      i {
        vertical-align: -0.08em;
      }
      span {
        .inline-block();
        margin-left: 10px;
      }
    }
    .por-box-b {
      width: 100%;
      height: 60px;
      background: #1b1b1b;
      .por-boxb-a {
        position: relative;
        width: 200px;
        height: 60px;
        font-size: 16px;
        text-align: center;
        float: left;
        border-right: 1px solid #272727;
        margin-left: -1px;
        &:hover,
        &.selected {
          .background-primary();
        }
        &:hover {
          .por-boxb-drop {
            visibility: visible;
            .por-boxb-drop-bg {
              visibility: visible;
              transform: translateY(0);
            }
          }
        }
        &:nth-child(3) {
          .por-boxb-drop {
            margin-left: -381px;
          }
        }
        &:nth-child(4) {
          .por-boxb-drop {
            margin-left: -381px;
          }
        }
        .por-boxb-title {
          display: block;
          width: 100%;
          height: 60px;
          line-height: 60px;
          color: white;
          .ellipsis();
          padding: 0 10px;
          cursor: pointer;
        }

        .por-boxb-drop {
          visibility: hidden;
          position: relative;
          z-index: 20;
          overflow: hidden;
          width: 600px;
          .por-boxb-drop-bg {
            width: 580px;
            visibility: hidden;
            padding: 20px 0px 0px 20px;
            background-color: rgba(255, 255, 255, 0.6);
            text-align: left;
            overflow-y: auto;
            .transTime(0.2s);
            transform: translateY(-100%);
          }
          .por-boxb-drop-item {
            position: relative;
            display: inline-block;
            width: 100px;
            margin-right: 10px;
            margin-bottom: 20px;
          }
          a {
            position: relative;
            display: inline-block;
            color: #666;
            width: 100px;
            background-color: rgba(255, 255, 255, 0.6);
            border-radius: 6px;
            padding: 5px 10px;
            font-size: 14px;
            text-align: center;
            .ellipsis();
            &:hover,
            &.selected {
              background-color: rgba(209, 235, 255, 0.9);
              color: #2282fa;
            }
          }
          .can-live {
            position: absolute;
            top: -16px;
            right: -4px;
            width: 70px;
            height: 20px;
            line-height: 20px;
            background-color: #e73d2e;
            color: #fff;
            font-weight: bold;
            border-radius: 3px;
            font-size: 12px;
            text-align: center;
          }
        }
      }
      .por-boxb-b {
        float: right;
        text-align: center;
        position: relative;
        height: 60px;
        padding-right: 12px;
        .por-boxb-title {
          margin-top: 12px;
          height: 36px;
          line-height: 34px;
          border: 1px solid #bbbbbb;
          background-color: #4e4e4e;
          color: white;
          font-size: 14px;
          cursor: pointer;
          padding-right: 5px;
          span {
            width: 100px;
            padding-left: 5px;
            .inline-block();
            .ellipsis();
          }
        }

        .por-boxb-list {
          position: absolute;
          background-color: #1b1b1b;
          width: 325px;
          top: 60px;
          right: -325px;
          // display: none;
          height: 500px;
          z-index: 100;
          overflow-y: auto;
          .transTime(0.2s);
          li {
            height: 50px;
            line-height: 50px;
            width: 100%;
            padding: 0 20px;
            &:hover,
            &.selected {
              .background-primary();
            }
            & > a {
              display: block;
              color: #fff;
              text-align: left;
              font-size: 16px;
              .ellipsis();
            }
          }
        }
        &:hover {
          .por-boxb-title {
            border: 1px solid transparent;
            background: linear-gradient(to right, #349eee, #6f98f9);
          }
          .por-boxb-list {
            right: 0;
          }
        }
        .por-boxb-drop {
          position: absolute;
          right: 325px;
          top: 60px;
          z-index: 20;
          width: 580px;
          height: 500px;
          padding: 20px 20px 20px 10px;
          background-color: rgba(255, 255, 255, 0.6);
          text-align: left;
          overflow-y: auto;
          .por-boxb-drop-item {
            position: relative;
            display: inline-block;
            width: 100px;
            margin-right: 10px;
            margin-bottom: 20px;
          }
          a {
            display: inline-block;
            color: #666;
            width: 100px;
            background-color: rgba(255, 255, 255, 0.6);
            border-radius: 6px;
            padding: 5px 10px;
            font-size: 14px;
            text-align: center;
            .ellipsis();
            &:hover,
            &.selected {
              background-color: rgba(209, 235, 255, 0.9);
              color: #2282fa;
            }
          }
          .can-live {
            position: absolute;
            top: -16px;
            right: -4px;
            width: 70px;
            height: 20px;
            line-height: 20px;
            background-color: #e73d2e;
            color: #fff;
            font-weight: bold;
            border-radius: 3px;
            font-size: 12px;
            text-align: center;
          }
        }
      }
    }
    .por-box-c {
      width: 864px;
      height: 500px;
      float: left;
      background: #1b1b1b;
      position: relative;
    }
    .por-box-d {
      width: 336px;
      height: 500px;
      float: left;
      background: #1b1b1b;
      padding: 12px 0 11px 0;
    }
  }
}
//通用标题
.topic-title {
  margin: 0 auto;
  width: 400px;
  height: 146px;
  // border: 2px solid #fff;
  // border-top-right-radius: 50px;
  // border-bottom-left-radius: 50px;
  background: url("../../assets/images/v3/special-m-title-dark.png") no-repeat;
  text-align: center;
  display: flex;
  align-items: center;
  .title-number {
    flex: 0 0 90px;
    width: 90px;
    height: 90px;
    background: #fff;
    line-height: 90px;
    font-size: 64px;
    font-weight: bold;
    margin-left: -45px;
    margin-top: 8px;
  }
  .title-text {
    flex: 1;
    color: #fff;
    font-size: 46px;
    letter-spacing: 6px;
    font-weight: bold;
    p {
      font-size: 18px;
      font-weight: normal;
      letter-spacing: 2px;
    }
  }
  &.blue {
    background: url("../../assets/images/v3/special-m-title-light.png")
      no-repeat;
    .title-number {
      background-color: #0d266a;
      color: #fff;
    }
    .title-text {
      color: #000;
    }
  }
}

.por-banner {
  background: url("../../assets/images/v3/special-m01-bg.png") no-repeat center
    bottom;
  padding-bottom: 100px;
  margin-bottom: -156px;
  .banner-title {
    // height: 140px;
    text-align: center;
  }
  .banner-list {
    width: 1200px;
    margin: 0 auto;
    // background: #fff;
    margin-top: 50px;
    display: flex;
    li {
      width: 400px;
      height: 390px;
      padding: 20px;
      .transTime(0.2s);
      .banner-item {
        width: 380px;
        height: 260px;
        box-shadow: 4px 4px 10px 2px rgba(0, 0, 0, 0.1);
        background: #fff;
        border-radius: 6px;
        overflow: hidden;
        // padding: 8px;
        cursor: pointer;
        .banner-icon {
          position: relative;
          width: 100%;
          height: 100%;
          overflow: hidden;
          text-align: center;
          img {
            position: absolute;
            left: 0;
            width: 100%;
            height: 100%;
            .transTime(0.2s);
            &:first-child {
              top: 0px;
            }
            &:last-child {
              top: 260px;
            }
          }
        }
        &:hover {
          .banner-icon {
            img {
              &:first-child {
                top: -220px;
              }
              &:last-child {
                top: 0px;
              }
            }
          }
        }
      }
      &:nth-child(2n + 1) {
        margin-top: 60px;
      }
      // &:hover {
      //   border-top-color: #2384fb;
      //   transform: scale(1.12);
      // }
    }
  }
}

// 班型图片
.class-type-img {
  width: 100%;
  min-height: 556px;
  text-align: center;
  background: url("../../assets/images/v3/special-m01-bg.png") no-repeat center
    bottom;
  .image {
    margin-top: 30px;
    padding-bottom: 30px;
    img {
      margin: 0 auto;
      max-width: 100%;
    }
  }
}

// 套餐班
.class-multip {
  background: #ebebeb url("../../assets/images/v3/special-m02-bg.png") no-repeat
    center top;
  min-height: 400px;
  padding-bottom: 60px;
}

// 单科班
.class-single {
  background: #fff url("../../assets/images/v3/special-m03-bg.png") no-repeat
    center top;
  min-height: 300px;
  padding-bottom: 60px;
}

//班型标题
.class-type-title {
  text-align: center;
  margin: 0px auto;
  padding: 60px 0 30px 0;
  img {
    display: inline-block;
  }
}
.por-box-wrapper {
  background: #fff;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  padding-bottom: 50px;
  box-shadow: 0 2px 5px 2px rgba(0, 0, 0, 0.1);
  border-bottom-left-radius: 100px;
  overflow: hidden;
}
//表格头班型Tab
.por-box-e {
  height: 70px;
  width: 100%;

  box-shadow: 0 2px 5px 2px rgba(0, 0, 0, 0.1);
  .por-boxe-b {
    position: relative;
    width: 120px;
    height: 70px;
    color: #666;
    font-size: 18px;
    line-height: 70px;
    text-align: center;
    float: left;
    cursor: pointer;
    padding: 0 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    &.selected {
      .background-primary();
      color: rgb(255, 255, 255);
      &:before {
        position: absolute;
        content: " ";
        border: 10px solid transparent;
        border-bottom: 10px solid #eee;
        bottom: -20px;
        left: 50px;
      }
    }
  }
  .por-boxe-other {
    float: right;
    width: 91px;
    height: 70px;
    cursor: pointer;
    border-left: solid #f2f2f2 1px;
    position: relative;
    text-align: center;
    line-height: 70px;
    // margin-top: -10px;
    &:hover {
      .por-boxe-drop {
        display: block;
      }
    }
    .por-boxe-drop {
      position: absolute;
      width: 250px;
      height: auto;
      background-color: #fff;
      padding: 10px 0 10px 10px;
      right: 0;
      display: none;
      z-index: 5;
      border-bottom-left-radius: 8px;
      box-shadow: 0 2px 4px 1px rgba(0, 0, 0, 0.1);
      li {
        float: left;
        width: 110px;
        height: 35px;
        line-height: 35px;
        text-align: left;
        margin-right: 10px;
        font-size: 14px;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}

//表格主体
.pro-box-content {
  padding: 20px;
}
//表格标题
.por-box-f {
  height: 56px;
  background: #eee;
  .por-boxf-a {
    width: 460px;
    height: 56px;
    float: left;
    line-height: 56px;
    font-size: 18px;
    text-align: center;
  }

  .por-boxf-b {
    width: 167px;
    height: 56px;
    float: left;
    line-height: 56px;
    font-size: 18px;
    text-align: center;
  }

  .por-boxf-c {
    width: 200px;
    height: 56px;
    float: left;
    line-height: 56px;
    font-size: 18px;
    text-align: center;
  }

  .por-boxf-d {
    width: 160px;
    height: 56px;
    float: left;
    line-height: 56px;
    font-size: 18px;
    text-align: center;
  }
}
//表格内容
.por-box-g {
  background: #fff;
  height: 56px;
  border-left: 1px solid #f2f2f2;
  border-right: 1px solid #f2f2f2;
  border-bottom: 1px solid #f2f2f2;
  position: relative;
  .can-integral {
    .can-integral();
    left: 0;
    top: 0;
  }
  .can-live {
    .can-live();
    left: -1px;
    bottom: 0;
  }
  .por-boxg-a {
    width: 460px;
    height: 56px;
    float: left;
    line-height: 56px;
    font-size: 16px;
    color: #666;
    text-align: left;
    // border-right: 1px solid #f2f2f2;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: 0 10px;
  }

  .por-boxg-b {
    width: 167px;
    height: 56px;
    float: left;
    color: #666;
    line-height: 56px;
    font-size: 16px;
    text-align: center;
    // border-right: 1px solid #f2f2f2;
  }

  .por-boxg-c {
    width: 200px;
    height: 56px;
    float: left;
    line-height: 56px;
    font-size: 16px;
    text-align: center;
    // border-right: 1px solid #f2f2f2;
    a {
      i {
        vertical-align: -0.08em;
      }
      color: #ff3115;
    }
  }

  .por-boxg-d {
    width: 160px;
    height: 56px;
    float: left;
    line-height: 56px;
    font-size: 16px;
    text-align: center;
    div {
      width: 80px;
      height: 30px;
      background: #fbe4dc;
      border: 1px solid #fd5c32;
      border-radius: 30px;
      text-align: center;
      line-height: 30px;
      color: #fd5c32;
      margin: 13px auto;
      cursor: pointer;
      // &:hover {
      //   background: #ff6600;
      // }
    }
  }
}
//专业介绍
.por-major-intro {
  width: 100%;
  text-align: center;
  /deep/ img {
    margin: 0 auto;
    max-width: 1190px;
  }
}
//表单入口
.form-entry {
  text-align: center;
  width: 100%;
  img {
    cursor: pointer;
    display: block;
    margin: 0 auto;
    max-width: 100%;
  }
}

//相关文章
.about-article-wrapper {
  width: 100%;
  background-color: #1d2e51;
  padding: 60px 0;
  .article-container {
    margin: 48px auto 0 auto;
    width: 1200px;
    position: relative;
    // background: url("../../assets/images/v3/article-wrapper-bg.png") no-repeat -10px
    //   30px;
    .article-item {
      margin-left: 30px;
      width: 1140px;
      border-bottom-right-radius: 30px;
      box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.1);
      background: #f9f9f9
        url("../../assets/images/theme/synth/hot-article-footer-bg.png")
        no-repeat right bottom;
      .article-title {
        height: 58px;
        line-height: 58px;
        background: url("../../assets/images/v3/article-title-bg.png") no-repeat;
        text-align: center;
        font-size: 18px;
        text-align: right;
        padding-right: 24px;
        a {
          color: #fff;
        }
      }
      .article-list {
        // height: 760px;
        max-height: 760px;
        padding: 0 24px;
        overflow: auto;
        .list-item {
          position: relative;
          padding: 16px;
          width: 100%;
          background: #fff;
          border-radius: 6px;
          box-shadow: 0 0 6px 1px rgba(0, 0, 0, 0.1);
          margin: 24px 0;
          overflow: hidden;
          a {
            position: absolute;
            right: 16px;
            color: #0e90d2;
            i {
              font-size: 16px;
            }
          }
          .list-title {
            font-size: 16px;
            font-weight: bold;
            .title-dot {
              display: inline-block;
              width: 22px;
              height: 20px;
              background: url("../../assets/images/v3/article-title-dot.png")
                no-repeat;
              vertical-align: middle;
              text-align: center;
              color: #fff;
              font-weight: normal;
              line-height: 1.4;
            }
            .title-text {
              width: 86%;
              .ellipsis();
              display: inline-block;
              vertical-align: middle;
              margin-left: 8px;
            }
          }
          .list-summary {
            visibility: hidden;
            max-height: 0;
            opacity: 0;
            transition: all 0.3s cubic-bezier(0, 1, 0, 1);
            &.extend {
              opacity: 1;
              visibility: visible;
              max-height: 2000px;
              transition: all 0.8s ease-in-out;
            }
            .summary-text {
              padding-top: 16px;
              /deep/ table {
                border: 1px solid #ccc;
                th,
                td {
                  border: 1px solid #ccc;
                  padding: 2px 4px;
                }
              }
            }
          }
        }
      }
    }
  }
}

//侧边导航
.sider-nav {
  position: fixed;
  left: 100px;
  top: 260px;
  width: 120px;
  background: #333;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.6);
  z-index: 200;
  .transTime(0.3s);
  &.put-away {
    left: -128px;
    .pos {
      right: -38px;
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.6);
    }
  }
  .pos {
    position: absolute;
    width: 30px;
    height: 40px;
    line-height: 40px;
    .transTime(0.3s);
    // .background-primary();
    background: #333;
    color: #fff;
    font-size: 22px;
    text-align: center;
    right: 120px;
    top: 50%;
    margin-top: -21px;
    cursor: pointer;
    box-shadow: -2px 0 3px rgba(0, 0, 0, 0.6);
  }
  .nav-item {
    position: relative;
    width: 100%;
    height: 60px;
    line-height: 60px;
    color: #fff;
    text-align: center;
    cursor: pointer;
    font-size: 16px;
    &:hover {
      .background-primary();
    }
    &.selected {
      .background-primary();
      &:after {
        position: absolute;
        content: " ";
        border: 8px solid transparent;
        border-left: 8px solid #2481fc;
        bottom: 23px;
        right: -16px;
      }
    }
  }
  .nav-qrcode {
    padding: 12px 0 24px 0;
    .qrcode-img {
      width: 90px;
      height: 90px;
      padding: 5px;
      background: #fff;
      margin: 0 auto;
      img {
        width: 80px;
        height: 80px;
      }
    }
    .qrcode-text {
      background: #fff;
      width: 90px;
      margin: 0 auto;
      text-align: center;
      height: 25px;
    }
  }
}
</style>
